/* build-tag: cache-bust-2026-07-24b */
/* All Moringa custom JS */

jQuery(".accordion_head").click(function () {
    if (jQuery('.accordion_body').is(':visible')) {
        jQuery(".accordion_body").slideUp(300);
        jQuery(".plusminus").text('+');
    }
    if (jQuery(this).next(".accordion_body").is(':visible')) {
        jQuery(this).next(".accordion_body").slideUp(300);
        jQuery(this).children(".plusminus").text('+');
    } else {
        jQuery(this).next(".accordion_body").slideDown(300);
        jQuery(this).children(".plusminus").text('-');
    }
});
$(document).ready(function(){
  $('.Product__Tabs .Collapsible__Button:first').attr('aria-expanded', 'true');
  $('.Product__Tabs .Collapsible__Inner:first').css({'overflow': 'hidden', 'height': 'auto'});
});

/* All Moringa: lander-style press strip + feature ticker on capsules PDP */
(function(){
  function amPress(){
    try{
      var slide=document.querySelector('[id*="slideshow_YAgUfc"]');
      if(slide){slide.style.display='none';}
      var sec=document.querySelector('[id*="custom_liquid_c87Vk9"]');
      if(sec && !sec.getAttribute('data-am-press')){
        sec.setAttribute('data-am-press','1');
        var names=['Forbes','ABC News','Real Simple','OK!','Yahoo Finance','Daily Mirror'];
        var spans=names.map(function(n){return `<span style="font-family:'Blacker Pro Display',Georgia,serif;font-weight:600;font-size:1.4rem;color:#6E6B57;letter-spacing:.04em;white-space:nowrap;">${n}</span>`;}).join('');
        sec.innerHTML=`<div style="text-align:center;padding:82px 20px 86px;"><div style="font-family:Montserrat,Arial,sans-serif;font-weight:600;font-size:.72rem;letter-spacing:.34em;text-transform:uppercase;color:#9C9781;margin-bottom:30px;">As seen on</div><div style="display:flex;flex-wrap:wrap;justify-content:center;align-items:center;gap:22px 52px;max-width:1040px;margin:0 auto;">${spans}</div></div>`;
        var words=['Full B-Complex','Complete Protein','Antioxidant Compounds','Lab tested','Non-GMO','Freeze-Dried Whole Leaf','Vegan Capsule','Family Owned'];
        var seq=words.concat(words);
        var tk=seq.map(function(w){return `<span class="am-tk">${w}</span>`;}).join('');
        var tick=document.createElement('div');
        tick.className='am-ticker';
        tick.setAttribute('aria-hidden','true');
        tick.innerHTML=`<div class="am-ticker-track">${tk}</div>`;
        sec.parentNode.insertBefore(tick,sec);
      }
    }catch(e){}
  }
  if(document.readyState!=='loading'){amPress();}else{document.addEventListener('DOMContentLoaded',amPress);}
})();

/* All Moringa: capsules PDP polish (2026-07-08, hardened 2026-07-24 — was racing theme hydration:
   fixed 1200/3000ms retries left a visible flash of 'None GMO' + narrow-column layout on real loads.
   A MutationObserver reacts the instant the product-info component finishes hydrating instead of guessing a delay. */
(function(){
  function amPdpPolish(){
    try{
      document.querySelectorAll('.pdp-feature .iconTitle').forEach(function(el){
        if(/None GMO/i.test(el.textContent)){el.textContent=el.textContent.replace(/None GMO/i,'Non-GMO');}
      });
      var tabs=document.querySelector('.product-info .Product__Tabs');
      var prod=document.querySelector('#main .product');
      if(tabs && prod && prod.parentNode && !document.querySelector('.am-tabs-wide')){
        var wrap=document.createElement('div');
        wrap.className='am-tabs-wide';
        wrap.appendChild(tabs);
        prod.parentNode.insertBefore(wrap,prod.nextSibling);
      }
    }catch(e){}
  }
  if(document.readyState!=='loading'){amPdpPolish();}else{document.addEventListener('DOMContentLoaded',amPdpPolish);}
  window.addEventListener('load',amPdpPolish);
  setTimeout(amPdpPolish,1200);
  setTimeout(amPdpPolish,3000);
  try{
    var amPdpObserver=new MutationObserver(function(){
      amPdpPolish();
      if(document.querySelector('.am-tabs-wide')){ amPdpObserver.disconnect(); }
    });
    amPdpObserver.observe(document.documentElement,{childList:true,subtree:true});
    setTimeout(function(){ try{ amPdpObserver.disconnect(); }catch(e){} },8000);
  }catch(e){}
})();

/* === AM_HIDE_AD_PLANS v3 (2026-07-13) ===
   The capsules product carries two Appstle plan groups:
   - 516194350 "Subscribe and Save 15/12/10" -> the one shoppers should see on the product page
   - 895221806 ads group (plans 1576861742 "30 Day Supply" 10%, 1576894510 "90 Days Supply" 20%)
     -> sold ONLY via the /pages/moringa-capsules-subscription lander cart links.
   This removes the ads plans from the Appstle widget's frequency dropdown and,
   if the widget's initial selection points at an ads plan, resyncs it to the
   first clean plan so the right price and perks text show.
   v3 adds: Appstle's own "SAVE X%" badge + preview price on the "Subscribe and Save"
   toggle render a stale value on first paint (the best discount across ALL plan groups
   attached to the product, including the hidden 895221806 ads group's 20% plan), even
   when the dropdown's own default selection is a real, correctly-priced Group 516194350
   plan. Confirmed live 2026-07-13: on load the badge reads "SAVE 20%" / $23.12 (the
   ads group's 90-Day per-jar price) next to a "Deliver every month" default that Shopify's
   own selling-plan data prices at 15% / $24.57. Firing one synthetic change event on the
   select (Appstle's already-correct recompute path, proven by manually reselecting the
   same option) fixes it without touching Appstle's app settings. Kicked once per widget
   via a data attribute so it never loops. */
(function () {
  if (window.location.pathname.indexOf('/products/') === -1) return;
  var AD_PLAN_IDS = ['1576861742', '1576894510'];
  var busy = false;

  function sweep() {
    if (busy) return;
    busy = true;
    try {
      AD_PLAN_IDS.forEach(function (id) {
        document.querySelectorAll('.appstle_subscription_wrapper option[value="' + id + '"]').forEach(function (o) {
          o.remove();
        });
      });
      document.querySelectorAll('.appstle_subscription_wrapper').forEach(function (w) {
        var sel = w.querySelector('select');
        if (!sel || !sel.options.length) return;
        var stale = AD_PLAN_IDS.indexOf(sel.value) !== -1 || sel.selectedIndex === -1;
        if (!stale) {
          var radios = w.querySelectorAll('input[type=radio]');
          for (var i = 0; i < radios.length; i++) {
            if (AD_PLAN_IDS.indexOf(radios[i].value) !== -1) { stale = true; break; }
          }
        }
        if (stale) {
          sel.value = sel.options[0].value;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
        } else if (!sel.dataset.amBadgeKicked) {
          sel.dataset.amBadgeKicked = '1';
          sel.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    } finally {
      busy = false;
    }
  }

  function start() {
    sweep();
    new MutationObserver(sweep).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
/* === end AM_HIDE_AD_PLANS v3 === */

/* === AM_PAGE_POLISH (2026-07-09) === */
(function(){
  var path = window.location.pathname;
  var COMPLIANCE_MAP = [
    [/helps? treat conditions like eczema and acne/gi, 'a favorite in routines for blemish-prone, easily irritated skin'],
    [/helps? reduce cholesterol levels?/gi, 'helps maintain cholesterol levels already in a normal range'],
    [/contributes to lowering cholesterol levels/gi, 'helps maintain cholesterol levels already in a normal range'],
    [/supports cardiovascular health/gi, 'supports heart health'],
    [/and has anti-inflammatory effects/gi, 'and supports a healthy inflammatory response'],
    [/provides anti-inflammatory and antioxidant effects/gi, 'provides antioxidant support and supports a healthy inflammatory response'],
    [/anti-inflammatory and skin-repairing properties/gi, 'skin-soothing, comforting properties'],
    [/helps reduce inflammation and supports/gi, 'supports a healthy inflammatory response and supports'],
    [/reduces inflammation, supports skin health/gi, 'supports a healthy inflammatory response, supports skin health'],
    [/and has potential anticancer properties/gi, 'and healthy cellular function'],
    [/aids in healing minor wounds and maintaining the skin barrier/gi, 'supports the skin’s natural renewal and helps maintain the skin barrier'],
    [/helps heal wounds and promotes the regeneration of skin cells/gi, 'supports the skin’s natural renewal and healthy skin-cell turnover'],
    [/supports wound healing/gi, 'supports the skin’s natural renewal'],
    [/helps? heal wounds\b/gi, 'supports the skin’s natural renewal'],
    [/\bheal(?:s|ing)? (?:minor )?wounds?\b/gi, 'support skin renewal'],
    [/\banticancer\b/gi, 'cell-supporting'],
    [/\bwound healing\b/gi, 'skin renewal'],
    [/\breduces inflammation\b/gi, 'supports a healthy inflammatory response'],
    [/\breduce inflammation\b/gi, 'support a healthy inflammatory response'],
    [/\banti-inflammatory\b/gi, 'soothing']
  ];
  function fixClaims(){
    try{
      var m=document.querySelector('#main'); if(!m) return;
      var walk=document.createTreeWalker(m, NodeFilter.SHOW_TEXT); var n;
      while((n=walk.nextNode())){
        var t=n.textContent; var orig=t;
        for(var i=0;i<COMPLIANCE_MAP.length;i++){ t=t.replace(COMPLIANCE_MAP[i][0], COMPLIANCE_MAP[i][1]); }
        if(t!==orig){
          if(orig.trim().charAt(0)===orig.trim().charAt(0).toUpperCase() && t.trim().charAt(0)!==t.trim().charAt(0).toUpperCase()){
            var lead=t.match(/^\s*/)[0]; var body=t.slice(lead.length); t=lead+body.charAt(0).toUpperCase()+body.slice(1);
          }
          n.textContent=t;
        }
      }
    }catch(e){}
  }
  var CTA_BY_PAGE = {
    '/pages/all-natural-vs-natural-explained': { h: 'The promise is in the product', p: 'Every jar and bottle holds the same All Natural standard you just read about.', btn: 'Shop All Moringa', href: '/collections/all' },
    '/pages/moringa-leaves-benefits': { h: 'Experience the leaf for yourself', p: 'Freeze-dried organic moringa leaf, for daily nutrition in capsules, powder, and tea.', btn: 'Shop Moringa for Health', href: '/collections/moringa-leaves-health-nutrition-products' },
    '/pages/moringa-seeds-the-tiny-titans-of-skin-and-health-benefits': { h: 'Experience the seed for yourself', p: 'Cold-pressed moringa seed oil, made for face, body, and hair.', btn: 'Shop Moringa for Skin', href: '/collections/moringa-magic-plant-powered-skincare-beauty' }
  };
  function addCta(){
    try{
      var cfg=CTA_BY_PAGE[path.replace(/\/$/,'')]; if(!cfg || document.querySelector('.am-page-cta')) return;
      var m=document.querySelector('#main'); if(!m) return;
      var el=document.createElement('div'); el.className='am-page-cta';
      el.innerHTML='<div class="am-page-cta__inner"><h2>'+cfg.h+'</h2><p>'+cfg.p+'</p><a class="am-page-cta__btn" href="'+cfg.href+'">'+cfg.btn+'</a></div>';
      m.appendChild(el);
    }catch(e){}
  }
  function fixContact(){
    try{
      var m=document.querySelector('#main'); if(!m) return;
      var walk=document.createTreeWalker(m, NodeFilter.SHOW_TEXT); var n;
      while((n=walk.nextNode())){ if(/Tell Us How Can We Help You/.test(n.textContent)){ n.textContent=n.textContent.replace(/Tell Us How Can We Help You/,'Tell Us How We Can Help You'); } }
    }catch(e){}
  }
  function run(){
    if(path.indexOf('/pages/moringa-leaves-benefits')===0){ fixClaims(); }
    if(path.indexOf('/pages/contact-us')===0){ fixContact(); }
    addCta();
  }
  if(document.readyState!=='loading'){run();}else{document.addEventListener('DOMContentLoaded',run);}
  window.addEventListener('load',run);
  setTimeout(run,1200); setTimeout(run,3000);
})();
/* === end AM_PAGE_POLISH === */

/* === AM_ABOUT_REDESIGN (2026-07-10) — editorial rebuild of /pages/about-us + brand story + conversion beats. Theme copy only. === */
(function(){
  if (window.location.pathname.indexOf('/pages/about-us') !== 0) return;
  var FAMILY_IMG='https://allmoringatree.com/cdn/shop/files/all-moringa-founders-family-photo_1200x.jpg?v=1766883349';
  var FARM_IMG='https://allmoringatree.com/cdn/shop/files/6_e9a32db0-1930-4c12-875a-18e913b57c34.jpg';
  var CAP='https://cdn.shopify.com/s/files/1/2131/9649/products/Capsules_0251_AllMoringaTree_Banners__2021YvetteRomanPhotograph025.jpg?v=1762527957';
  var OIL='https://cdn.shopify.com/s/files/1/2131/9649/products/Oil-1_0251_AllMoringaTree_Banners__2021YvetteRomanPhotograph025.jpg?v=1762527957';
  var POW='https://cdn.shopify.com/s/files/1/2131/9649/products/Powder-1_0251_AllMoringaTree_Banners__2021YvetteRomanPhotograph025.jpg?v=1762527964';
  var CREAM='https://cdn.shopify.com/s/files/1/2131/9649/files/new_moringa_cream_glass_jar.png?v=1762527963';
  var STYLE='<style>'+
'.am-about__quote{background:#333A20 !important;border-radius:8px !important;text-align:center;padding:62px 40px 56px !important;margin:12px 0 66px !important;}'+
'.am-about__quote .am-eyebrow{color:#B9C09A !important;text-align:center;}'+
'.am-about__quote-line{font-size:2.3rem !important;line-height:1.2 !important;margin:0 auto 18px !important;max-width:760px;text-wrap:balance;}'+
'.am-about__quote-sub{max-width:600px !important;margin:0 auto !important;font-size:1.05rem !important;line-height:1.65;text-wrap:pretty;}'+
'.am-about__pillars{display:grid;grid-template-columns:repeat(3,1fr);margin:46px auto 0;max-width:860px;border-top:1px solid rgba(244,241,230,.18);}'+
'.am-about__pillar{padding:30px 26px 6px;border-right:1px solid rgba(244,241,230,.18);text-align:center;}'+
'.am-about__pillar:last-child{border-right:none;}'+
".am-about__pillar h4{font-family:'Blacker Pro Display',Georgia,serif;font-weight:600;font-size:1.15rem;color:#F4F1E6 !important;margin:0 0 9px;}"+
'.am-about__pillar p{color:#C7CBB0 !important;font-size:.92rem;line-height:1.55;margin:0;}'+
'.am-about__cta-sub{font-size:.92rem;color:#5E5C48;margin:20px auto 0 !important;max-width:560px;line-height:1.55;}'+
'.am-about__press{margin:0 0 62px;padding:34px 0;border-top:1px solid #E8E4D8;border-bottom:1px solid #E8E4D8;}'+
'.am-about__press-row{display:flex;flex-wrap:wrap;justify-content:center;align-items:center;gap:18px 46px;margin-top:20px;}'+
".am-about__press-row span{font-family:'Blacker Pro Display',Georgia,serif;font-weight:600;font-size:1.3rem;color:#6E6B57;white-space:nowrap;}"+
'.am-about__proof{text-align:center;margin-bottom:66px;}'+
'.am-about__proof-head{display:flex;flex-direction:column;align-items:center;gap:4px;margin-bottom:34px;}'+
'.am-about__stars{color:#C9A24B;font-size:1.45rem;letter-spacing:3px;}'+
".am-about__proof-num{font-family:'Blacker Pro Display',Georgia,serif;font-size:1.5rem;color:rgb(var(--accent));}"+
'.am-about__proof-sub{font-size:.9rem;color:#807C6A;}'+
'.am-about__reviews{display:grid;grid-template-columns:repeat(3,1fr);gap:22px;text-align:left;}'+
'.am-about__review{background:#FFFFFF;border:1px solid #E8E4D8;border-radius:6px;padding:26px 26px 22px;margin:0;}'+
'.am-about__rstars{color:#C9A24B;font-size:.95rem;letter-spacing:1px;margin-bottom:10px;}'+
".am-about__review blockquote{font-size:1rem;line-height:1.55;color:#3B3A33;margin:0 0 16px;font-family:'Inter','Helvetica Neue',Arial,sans-serif;}"+
'.am-about__review figcaption{font-size:.85rem;font-weight:600;color:#33321F;}'+
'.am-about__review figcaption span{display:block;font-weight:400;color:#9C9781;font-size:.78rem;margin-top:2px;}'+
'.am-about__grid-wrap{margin-bottom:66px;}'+
'.am-about__grid-wrap h2{text-align:center;margin:0 0 32px;}'+
'.am-about__grid{display:grid;grid-template-columns:repeat(4,1fr);gap:22px;}'+
'.am-about__pcard{display:block;text-decoration:none !important;background:#FFFFFF;border:1px solid #E8E4D8;border-radius:6px;padding:14px 14px 20px;transition:box-shadow .2s,transform .2s;}'+
'.am-about__pcard:hover{box-shadow:0 10px 26px rgba(51,58,32,.12);transform:translateY(-2px);}'+
'.am-about__pimg{background:#F7F5F1;border-radius:4px;overflow:hidden;aspect-ratio:1/1;margin-bottom:14px;}'+
'.am-about__pimg img{width:100%;height:100%;object-fit:cover;}'+
'.am-about__prating{color:#C9A24B;font-size:.82rem;}'+
'.am-about__prating span{color:#807C6A;}'+
".am-about__pcard h3{font-size:1rem;line-height:1.3;margin:6px 0 8px;color:#33321F !important;font-weight:600 !important;}"+
".am-about__price{font-family:'Blacker Pro Display',Georgia,serif;font-size:1.15rem;color:rgb(var(--accent));}"+
'@media screen and (max-width:880px){.am-about__reviews{grid-template-columns:1fr;}.am-about__grid{grid-template-columns:1fr 1fr;}.am-about__press-row span{font-size:1.1rem;}.am-about__pillars{grid-template-columns:1fr;max-width:420px;}.am-about__pillar{border-right:none;border-bottom:1px solid rgba(244,241,230,.18);padding:20px 0 16px;}.am-about__pillar:last-child{border-bottom:none;}.am-about__quote-line{font-size:1.5rem !important;}.am-about__quote{padding:46px 24px 40px !important;}}'+
'</style>';
  function pcard(href,img,alt,title,num,price){
    return '<a class="am-about__pcard" href="'+href+'"><div class="am-about__pimg"><img src="'+img+'" alt="'+alt+'" loading="lazy"></div><div class="am-about__prating">★ 4.8 <span>('+num+')</span></div><h3>'+title+'</h3><span class="am-about__price">'+price+'</span></a>';
  }
  function review(quote,name){
    return '<figure class="am-about__review"><div class="am-about__rstars">★★★★★</div><blockquote>“'+quote+'”</blockquote><figcaption>'+name+' <span>Verified buyer</span></figcaption></figure>';
  }
  function build(){
    try{
      var sec=document.getElementById('shopify-section-about-us-page');
      if(!sec || sec.getAttribute('data-am-about')) return;
      sec.setAttribute('data-am-about','1');
      sec.innerHTML=STYLE+[
'<div class="am-about">',
'  <div class="am-about__hero">',
'    <div class="am-about__hero-text">',
'      <div class="am-eyebrow">Our story</div>',
'      <h1>Health and wellness, from our family to you</h1>',
'      <p class="am-about__lede">Hello! We’re Maya and Tzvi, the founders of All Moringa, a family-owned wellness company dedicated to bringing the power of the Miracle Tree into your home.</p>',
'      <p>Our journey began over 25 years ago, when Tzvi was working as a project manager on a passion fruit farm in Ghana. During that time, he was sick on and off for what felt like forever, low on energy and run down.</p>',
'      <p>The farm manager, who used moringa leaf every day, noticed what Tzvi was going through and suggested he try it. He did. Before long, his energy came back. He was sleeping better, his digestion settled, and he stopped catching every bug going around.</p>',
'    </div>',
'    <div class="am-about__hero-img"><img src="'+FAMILY_IMG+'" alt="Maya, Tzvi and their daughters, the All Moringa family" loading="eager"></div>',
'  </div>',
'  <div class="am-about__story">',
'    <div class="am-about__story-img"><img src="'+FARM_IMG+'" alt="Moringa trees growing on the farm" loading="lazy"></div>',
'    <div class="am-about__story-text">',
'      <div class="am-eyebrow">One family, one tree</div>',
'      <p>As a farmer and a plant lover, something clicked for Tzvi that most people would have walked right past. He became fascinated by this one tree, and he started to dig.</p>',
'      <p>The deeper he looked, the more remarkable it got. Not one benefit, but many. Not one part, but the whole tree, from the nutrient-dense leaf to the cold-pressed seed. And a history going back generations, whole families and communities who trusted moringa as everyday nourishment long before anyone called it a superfood.</p>',
'      <p>He never looked at wellness the same way again.</p>',
'      <p>Years later, he met Maya. In 2016, she was a luxury wedding photographer, and the two of them fell in love, with each other and with this one tree. Together they decided to finally share what Tzvi had known for so long, and All Moringa was born.</p>',
'      <p>Today, as a husband-and-wife team, we have three babies: two beautiful daughters and one thriving, family-run moringa business.</p>',
'      <p class="am-about__welcome">Welcome to the family.</p>',
'      <p class="am-about__sig">Maya &amp; Tzvi</p>',
'    </div>',
'  </div>',
'  <div class="am-about__quote">',
'    <div class="am-eyebrow">Our promise to you</div>',
'    <p class="am-about__quote-line">One tree. Whole-body care.<br>From leaf to seed.</p>',
'    <p class="am-about__quote-sub">What a farm manager once shared with Tzvi in Ghana, we now source, test, and bring to your home. The whole tree, nothing diluted and nothing synthetic, held to the same standard we would want for our own family.</p>',
'    <div class="am-about__pillars">',
'      <div class="am-about__pillar"><h4>The leaf</h4><p>Freeze-dried organic whole leaf for the nutrition you take and drink, in capsules, powder, and tea.</p></div>',
'      <div class="am-about__pillar"><h4>The seed</h4><p>Cold-pressed organic seed oil for the skin, hair, and body you care for every day.</p></div>',
'      <div class="am-about__pillar"><h4>One source</h4><p>Both from the same organic tree, grown in India for generations and rooted in its Ayurvedic tradition.</p></div>',
'    </div>',
'  </div>',
'  <div class="am-about__cards">',
'    <div class="am-about__card">',
'      <div class="am-eyebrow">Our mission</div>',
'      <p>We are as committed to your health and well-being as we are to our own. That’s why we lead with education and honest transparency, and why what you take and what you put on your skin get the very same care.</p>',
'      <p>Our goal is simple: make bringing moringa into your life easy, effective, and something you actually enjoy.</p>',
'    </div>',
'    <div class="am-about__card">',
'      <div class="am-eyebrow">Our promise</div>',
'      <p>Purity and quality are non-negotiable. Every product is:</p>',
'      <ul class="am-about__checks">',
'        <li><strong>Pure &amp; Organic:</strong> no synthetic additives, GMOs, or toxins</li>',
'        <li><strong>Tested:</strong> verified for microbiology and heavy metals</li>',
'        <li><strong>Glass-Packed:</strong> bottled in dark glass, never plastic, to protect potency</li>',
'        <li><strong>Raw &amp; Nutrient-Rich:</strong> 90+ nutrients and plant compounds, including 18 amino acids</li>',
'        <li><strong>Vegan &amp; Cruelty-Free:</strong> never tested on animals</li>',
'        <li><strong>Gluten &amp; Paraben-Free:</strong> safe, clean, and suitable for all dietary needs</li>',
'      </ul>',
'      <p class="am-about__never">And never any preservatives, artificial flavors, unnecessary additives, or synthetic fillers.</p>',
'    </div>',
'  </div>',
'  <div class="am-about__why">',
'    <div class="am-eyebrow" style="text-align:center;">Why choose All Moringa</div>',
'    <div class="am-about__why-grid">',
'      <div><h3>Tested for purity &amp; potency</h3><p>Premium 100% organic raw Moringa, every single batch.</p></div>',
'      <div><h3>One ingredient, nothing else</h3><p>Just moringa, never a diluted blend or filler.</p></div>',
'      <div><h3>No shortcuts, ever</h3><p>Every batch meets USDA Certified Organic and RAW standards.</p></div>',
'      <div><h3>Fast, free U.S. shipping</h3><p>On all orders over $55.</p></div>',
'    </div>',
'  </div>',
'  <div class="am-about__press">',
'    <div class="am-eyebrow" style="text-align:center;">As seen in</div>',
'    <div class="am-about__press-row"><span>Forbes</span><span>ABC News</span><span>Real Simple</span><span>OK!</span><span>Yahoo Finance</span><span>Daily Mirror</span></div>',
'  </div>',
'  <div class="am-about__proof">',
'    <div class="am-about__proof-head"><span class="am-about__stars">★★★★★</span><span class="am-about__proof-num">4.8 out of 5</span><span class="am-about__proof-sub">from 700+ verified customer reviews</span></div>',
'    <div class="am-about__reviews">',
'      '+review('Excellent service and very fast delivery. The product speaks for itself.','Catalin P.'),
'      '+review('It came in dark glass, fresh and tasty. Exactly what I expected from a true organic supplement.','Barbara M.'),
'      '+review('The moringa is helping me feel better. Thank you so much.','Sara T.'),
'    </div>',
'  </div>',
'  <div class="am-about__grid-wrap">',
'    <div class="am-eyebrow" style="text-align:center;">Shop the family</div>',
'    <h2>Where would you like to start?</h2>',
'    <div class="am-about__grid">',
'      '+pcard('/products/organic-moringa-capsules',CAP,'Organic Moringa Capsules','Organic Moringa Capsules','155','$28.90'),
'      '+pcard('/products/organic-moringa-oil',OIL,'Moringa Seed Oil','Moringa Seed Oil','106','From $23.90'),
'      '+pcard('/products/organic-moringa-powder',POW,'Organic Moringa Leaf Powder','Organic Leaf Powder','155','$28.90'),
'      '+pcard('/products/therapeutic-organic-moringa-moisturizing-face-cream-anti-wrinkle-aging',CREAM,'Moringa Face Cream','Moringa Face Cream','112','$26.90'),
'    </div>',
'  </div>',
'  <div class="am-about__cta">',
'    <h2>Bring the whole tree home</h2>',
'    <p>Start where our story started, with the leaf, or explore the full family of leaf and seed.</p>',
'    <div class="am-about__cta-row"><a class="am-about__btn" href="/collections/all">Shop All Moringa</a><a class="am-about__link" href="/products/organic-moringa-capsules">Start with the capsules</a></div>',
'    <p class="am-about__cta-sub">Prefer to never run out? Subscribe on any product and save up to 15%. Skip, pause, or cancel anytime, with your price locked in for good.</p>',
'    <p class="am-about__wholesale">For wholesale or bulk orders, email <a href="mailto:info@allmoringatree.com">info@allmoringatree.com</a>.</p>',
'  </div>',
'</div>'
      ].join('');
    }catch(e){}
  }
  if(document.readyState!=='loading'){build();}else{document.addEventListener('DOMContentLoaded',build);}
  window.addEventListener('load',build);
  setTimeout(build,1200);
  setTimeout(build,3000);
})();
/* === end AM_ABOUT_REDESIGN === */

/* === AM_IMAGE_FRAME (2026-07-10) — delicate hairline frame on product / blog / cart / gallery / sticky-bar / FBT / editorial images, site-wide.
   SKIPS any image sitting on a pure-white background (those blend by design — Tzvi rule 2026-07-10).
   Injected globally so it also covers dynamically rendered cards (cart drawer, quick-add, ajax grids). === */
(function(){
  var css=''+
    '.product-card__media{border:1px solid #E8E4D8 !important;border-radius:8px;overflow:hidden;background:#FFFFFF;}'+
    '.product-gallery__media{border:1px solid #E8E4D8 !important;border-radius:10px;overflow:hidden;}'+
    '.product-sticky-bar variant-media{border:1px solid #E8E4D8 !important;border-radius:6px;overflow:hidden;display:inline-block;}'+
    '.cbb-frequently-bought-product-image{border:1px solid #E8E4D8 !important;border-radius:8px;background-clip:padding-box;}'+
    '.FeatureText__ImageWrapper{border:1px solid #E8E4D8 !important;border-radius:8px;overflow:hidden;}'+
    '.multi-column__item a.overflow-hidden{border:1px solid #E8E4D8 !important;border-radius:8px;overflow:hidden;}'+
    '.media-grid__item{border:1px solid #E8E4D8 !important;border-radius:8px;overflow:hidden;}'+
    '.blog-post-card a.overflow-hidden{border:1px solid #E8E4D8 !important;border-radius:8px;overflow:hidden;}'+
    '.line-item__media{border:1px solid #E8E4D8 !important;border-radius:6px;}'+
    '[data-am-frame="off"]{border:0 !important;border-radius:0 !important;}';
  if(!document.getElementById('am-image-frame-style')){
    var s=document.createElement('style');
    s.id='am-image-frame-style';
    s.textContent=css;
    (document.head||document.documentElement).appendChild(s);
  }
  var SEL='.product-card__media,.product-gallery__media,.product-sticky-bar variant-media,.cbb-frequently-bought-product-image,.FeatureText__ImageWrapper,.multi-column__item a.overflow-hidden,.media-grid__item,.blog-post-card a.overflow-hidden,.line-item__media';
  function effBg(el){
    while(el && el.nodeType===1){
      var c=getComputedStyle(el).backgroundColor;
      if(c && c!=='rgba(0, 0, 0, 0)' && c!=='transparent') return c;
      el=el.parentElement;
    }
    return '';
  }
  function isWhite(c){ return c==='rgb(255, 255, 255)' || c==='rgba(255, 255, 255, 1)'; }
  function sweep(){
    try{
      document.querySelectorAll(SEL).forEach(function(el){
        var bg=effBg(el.parentElement);
        if(isWhite(bg)) el.setAttribute('data-am-frame','off'); else el.removeAttribute('data-am-frame');
      });
    }catch(e){}
  }
  var pending=false;
  function schedule(){ if(pending) return; pending=true; setTimeout(function(){pending=false; sweep();},150); }
  if(document.readyState!=='loading'){ sweep(); } else { document.addEventListener('DOMContentLoaded',sweep); }
  window.addEventListener('load',sweep);
  setTimeout(sweep,1200); setTimeout(sweep,3000);
  try{ new MutationObserver(schedule).observe(document.documentElement,{childList:true,subtree:true}); }catch(e){}
})();
/* === end AM_IMAGE_FRAME === */

/* === AM_PAGE_SECTION_FIXES (2026-07-10) — hide duplicate/unwanted theme sections (draft only; the leaf-benefits template is 70KB so we override rather than hand-edit the JSON). === */
(function(){
  if(document.getElementById('am-section-fixes-style')) return;
  var css=''+
    '[id*="collection_list_wbawKg"]{display:none !important;}'+
    '[id*="eb1f7ba5"]{display:none !important;}';
  var s=document.createElement('style');
  s.id='am-section-fixes-style';
  s.textContent=css;
  (document.head||document.documentElement).appendChild(s);
})();
/* === end AM_PAGE_SECTION_FIXES === */

/* === AM_PRODUCT_CARD (2026-07-11) — square product images (theme was aspect-tall 2:3), larger title/price + breathing room below the image, and a fix for the hover 2nd-image going blank white. === */
(function(){
  if(!document.getElementById('am-product-card-style')){
    var css=''+
      '.product-card__image{aspect-ratio:1/1 !important;}'+
      '.product-card__info{margin-top:15px !important;}'+
      '.product-card__info .product-title{font-size:15px !important;line-height:1.35 !important;}'+
      '.product-card__info .price-list{font-size:18px !important;}';
    var s=document.createElement('style');
    s.id='am-product-card-style';
    s.textContent=css;
    (document.head||document.documentElement).appendChild(s);
  }
  function forceLoad(img){
    if(!img || (img.complete && img.naturalWidth>0)) return;
    var src=img.getAttribute('src'); if(!src) return;
    img.setAttribute('loading','eager');
    img.removeAttribute('src'); img.setAttribute('src', src);
  }
  function loadAll(){ try{ document.querySelectorAll('.product-card__image--secondary').forEach(forceLoad); }catch(e){} }
  if(document.readyState==='complete'){ setTimeout(loadAll,1200); } else { window.addEventListener('load', function(){ setTimeout(loadAll,1200); }); }
  document.addEventListener('mouseover', function(e){
    try{ var fig=e.target.closest && e.target.closest('.product-card, .product-card__figure'); if(fig){ forceLoad(fig.querySelector('.product-card__image--secondary')); } }catch(err){}
  }, {passive:true});
})();
/* === end AM_PRODUCT_CARD === */

/* === AM_HOME_WAVE1 (2026-07-11, v6) — homepage hero proof/CTA + inside-out router + serif press strip + copy fixes. Draft theme only.
   CSS lives in assets/am-reskin.css (AM_HOME_MIGRATED block, 2026-08-09; the old am-home.css loader was removed - the CDN never honored its manual ?v= cache-bust). === */
(function(){
  if(window.location.pathname!=='/' && window.location.pathname!=='/index'){ return; }
  function run(){
    try{
      var slideSec=document.querySelector('#main .shopify-section--slideshow');
      if(slideSec && !slideSec.getAttribute('data-am-home')){
        slideSec.setAttribute('data-am-home','1');
        slideSec.classList.add('am-home-hero');
        /* 2026-09-25: every slide gets the frame, not only the first, so swapping or adding slides in the customizer keeps it. */
        slideSec.querySelectorAll('.slideshow__slide-content .prose').forEach(function(prose,idx){
          if(!prose.querySelector('h1, .h1')){
            var h=document.createElement(idx===0?'h1':'p');
            h.className='h1';
            h.textContent='One Tree. Whole-Body Care. From Leaf To Seed.';
            prose.insertBefore(h,prose.firstChild);
          }
          if(!prose.querySelector('.am-hero-proof')){
            var chip=document.createElement('div');
            chip.className='am-hero-proof';
            chip.innerHTML='<span class="am-hero-stars">★★★★★</span><span>4.8 from 700+ verified reviews</span>';
            var kicker=prose.querySelector('p.h6');
            if(kicker){kicker.parentNode.replaceChild(chip,kicker);}
            else{prose.insertBefore(chip,prose.firstChild);}
          }
          if(!prose.querySelector('.am-hero-sub')){
            var add=document.createElement('div');
            add.innerHTML='<p class="am-hero-sub">Nutrition from the leaf. Skincare from the seed. Real wellness your whole body recognizes.</p>'+
              '<div class="am-hero-ctas"><a class="am-hero-btn" href="/collections/all">Shop Best Sellers</a><a class="am-hero-link" href="#am-router">Find your ritual</a></div>'+
              '<p class="am-hero-ship">Free U.S. shipping over $55 · Family owned since 2017</p>';
            while(add.firstChild){prose.appendChild(add.firstChild);}
          }
        });
      }
      var press=document.querySelector('#main .shopify-section--scrolling-content');
      if(press && !press.getAttribute('data-am-press')){
        press.setAttribute('data-am-press','1');
        var names=['Forbes','ABC News','Real Simple','OK!','Yahoo Finance','Daily Mirror'];
        var spans='';
        for(var i=0;i<names.length;i++){
          spans+='<span style="font-family:\'Blacker Pro Display\',Georgia,serif;font-weight:600;font-size:1.4rem;color:#6E6B57;letter-spacing:.04em;white-space:nowrap;">'+names[i]+'</span>';
        }
        press.innerHTML='<div style="text-align:center;padding:56px 20px 60px;"><div style="font-family:Montserrat,Arial,sans-serif;font-weight:600;font-size:.72rem;letter-spacing:.34em;text-transform:uppercase;color:#9C9781;margin-bottom:26px;">As seen on</div><div style="display:flex;flex-wrap:wrap;justify-content:center;align-items:center;gap:20px 52px;max-width:1040px;margin:0 auto;">'+spans+'</div></div>';
      }
      var routerSec=document.querySelector('#main .shopify-section--collection-list');
      if(routerSec && !routerSec.getAttribute('data-am-router')){
        routerSec.setAttribute('data-am-router','1');
        /* 2026-09-25: the router is no longer moved up under the press strip. Its place (below Best Sellers)
           is set in templates/index.json, so the customizer shows the real order. */
        if(!document.getElementById('am-router')){
          var anchor=document.createElement('div');
          anchor.id='am-router';
          routerSec.parentNode.insertBefore(anchor,routerSec);
        }
        var head=routerSec.querySelector('.section-header .prose');
        if(head){
          var h2=head.querySelector('.h2');
          if(h2){h2.textContent='Where would you like to start?';}
          if(!head.querySelector('.am-router-sub')){
            var sub=document.createElement('p');
            sub.className='am-router-sub';
            sub.textContent='One tree, three ways in. Nourish from the inside, care for the outside, or bring the whole ritual home.';
            head.appendChild(sub);
          }
        }
        /* Outcome-led labels (CRO rec, Tzvi go 2026-07-29): the big line is the OUTCOME, the
           leaf/seed vocabulary stays as the small chip (the ritual section below teaches it). */
        var LABELS=[['skincare-beauty','From the seed','For your skin','Shop Skincare'],['health-nutrition','From the leaf','For your daily nutrition','Shop Nutrition'],['kits-bundles','Leaf + Seed','The complete ritual','Shop Bundles']];
        routerSec.querySelectorAll('a.collection-card').forEach(function(card){
          var href=card.getAttribute('href')||'';
          for(var i=0;i<LABELS.length;i++){
            if(href.indexOf(LABELS[i][0])!==-1){
              var k=card.querySelector('.collection-card__content p');
              var b=card.querySelector('.collection-card__content button');
              if(k){k.textContent=LABELS[i][1];}
              if(k && !card.querySelector('.am-router-primary')){
                var prim=document.createElement('p');
                prim.className='am-router-primary';
                prim.textContent=LABELS[i][2];
                k.parentNode.insertBefore(prim,k.nextSibling);
              }
              /* Chip + headline live ABOVE the image as a card header (Tzvi 2026-07-29:
                 overlaid on the photo they read badly); only the button stays on the image. */
              if(!card.querySelector('.am-router-cardhead')){
                var ch=document.createElement('div');
                ch.className='am-router-cardhead';
                card.insertBefore(ch,card.firstChild);
                if(k){ch.appendChild(k);}
                var pr=card.querySelector('.am-router-primary');
                if(pr){ch.appendChild(pr);}
              }
              if(b){b.textContent=LABELS[i][3];}
              if(!card.getAttribute('data-am-ga')){
                card.setAttribute('data-am-ga','1');
                var slug=LABELS[i][0];
                card.addEventListener('click',function(){
                  try{
                    if(typeof window.gtag==='function'){window.gtag('event','am_router_click',{card:slug});}
                    else if(window.dataLayer){window.dataLayer.push({event:'am_router_click',card:slug});}
                  }catch(e){}
                });
              }
              break;
            }
          }
        });
      }
      var mt=document.querySelector('#main .FeatureText .SectionHeader__Description');
      if(mt && mt.innerHTML.indexOf('—naturally')!==-1){
        mt.innerHTML=mt.innerHTML.replace(/—naturally/g,', naturally');
      }
      document.querySelectorAll('#main .ctm-btn a[href="/collections"]').forEach(function(a){a.setAttribute('href','/collections/all');});
      var disc=document.getElementById('am-disclaimer');
      if(disc && disc.innerHTML.indexOf('categories—individual')!==-1){
        disc.innerHTML=disc.innerHTML.replace(/categories—individual/g,'categories; individual');
      }
    }catch(e){}
  }
  if(document.readyState!=='loading'){run();}else{document.addEventListener('DOMContentLoaded',run);}
  window.addEventListener('load',run);
  setTimeout(run,1200);setTimeout(run,3000);
})();
/* === end AM_HOME_WAVE1 === */

/* === AM_HOME_WAVE2 (2026-07-11, v2) — smooth scroll from the hero "Find your ritual" link to the router.
   Original card-rating injection REMOVED: Loox renders native lazy-loaded rating rows on cards. === */
(function(){
  if(window.location.pathname!=='/' && window.location.pathname!=='/index'){ return; }
  function smooth(){
    try{
      var l=document.querySelector('.am-hero-link[href="#am-router"]');
      if(l && !l.getAttribute('data-am-smooth')){
        l.setAttribute('data-am-smooth','1');
        l.addEventListener('click',function(ev){
          var t=document.getElementById('am-router');
          if(t){ev.preventDefault();t.scrollIntoView({behavior:'smooth',block:'start'});}
        });
      }
    }catch(e){}
  }
  if(document.readyState!=='loading'){smooth();}else{document.addEventListener('DOMContentLoaded',smooth);}
  window.addEventListener('load',smooth);
  setTimeout(smooth,1200);setTimeout(smooth,3000);
})();
/* === end AM_HOME_WAVE2 === */

/* === AM_KLAVIYO_COPY (was AM_HOME_REORDER; the section moves + kits-eyebrow swap were baked into
   templates/index.json 2026-08-08 and removed from here 2026-08-09) — Klaviyo signup band copy, voice
   pass: sentence case per the design system, "and" over "&" per plain-English voice. Klaviyo renders
   async, so the late retry ticks below are still load-bearing. Styling lives in am-reskin.css
   AM_NEWSLETTER. === */
(function(){
  if(window.location.pathname!=='/' && window.location.pathname!=='/index'){ return; }
  function reorder(){
    try{
      var email=document.querySelector('#main [id*="1749243962220db41c"]');
      /* Newsletter copy, voice pass 2026-08-04 (styling lives in am-reskin.css AM_NEWSLETTER):
         sentence case per the design system, "and" over "&" per plain-English voice. Text-node
         replacement so Klaviyo's markup stays untouched; exact-match makes it idempotent and the
         late retry ticks below catch Klaviyo's async render. */
      if(email){
        var wlk=document.createTreeWalker(email,NodeFilter.SHOW_TEXT);var tn;
        while((tn=wlk.nextNode())){
          var t0=tn.textContent;
          var t1=t0.replace('From the Moringa Tree to You','From the moringa tree to you')
                   .replace('Early access, honest education, & 15% off your first order.','Early access, honest education, and 15% off your first order.')
                   .replace('Join & Save 15%','Join and save 15%');
          if(t1!==t0){tn.textContent=t1;}
        }
      }
    }catch(e){}
  }
  if(document.readyState!=='loading'){reorder();}else{document.addEventListener('DOMContentLoaded',reorder);}
  window.addEventListener('load',reorder);
  setTimeout(reorder,1200);setTimeout(reorder,3000);setTimeout(reorder,5000);setTimeout(reorder,8000);setTimeout(reorder,12000);
})();
/* === end AM_KLAVIYO_COPY === */

/* === AM_ANNOUNCEMENT_VOICE (2026-08-04) — voice hard rule: no em dashes, anywhere. The rotating
   announcement bar carried "Subscribe & Save 15-20% — every delivery" (caught by Tzvi in a screenshot;
   the 08-04 voice scan only walked #main and the bar lives in the header). Sitewide, no path guard.
   The bar is a rotating carousel, so re-apply on ticks + a MutationObserver on the bar itself. === */
(function(){
  function fix(){
    try{
      document.querySelectorAll('.announcement-bar, announcement-bar').forEach(function(bar){
        var walk=document.createTreeWalker(bar,NodeFilter.SHOW_TEXT);var tn;
        while((tn=walk.nextNode())){
          if(tn.textContent.indexOf('—')!==-1){
            tn.textContent=tn.textContent.replace(/\s*—\s*/g,', ');
          }
        }
      });
    }catch(e){}
  }
  function start(){
    fix();
    try{
      var bar=document.querySelector('.announcement-bar, announcement-bar');
      if(bar){new MutationObserver(fix).observe(bar,{childList:true,subtree:true,characterData:true});}
    }catch(e){}
    setTimeout(fix,1200);setTimeout(fix,3000);
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',start);}else{start();}
})();
/* === end AM_ANNOUNCEMENT_VOICE === */

/* === AM_HOME_P24 (2026-07-11) — Pillar 24 headline on the comparison-chart section (Tzvi "go"). The original
   "One Leaf, Many Essentials" heading text is KEPT on-page as the eyebrow above it (SEO preservation: nothing removed). === */
(function(){
  if(window.location.pathname!=='/' && window.location.pathname!=='/index'){ return; }
  function swap(){
    try{
      if(document.querySelector('[data-am-p24]')) return;
      var heads=document.querySelectorAll('#main h1, #main h2, #main h3, #main .h1, #main .h2');
      for(var i=0;i<heads.length;i++){
        var el=heads[i];
        if(el.textContent.trim().toLowerCase()==='one leaf, many essentials'){
          el.setAttribute('data-am-p24','1');
          var eyebrow=document.createElement('div');
          eyebrow.className='am-eyebrow';
          eyebrow.style.textAlign='center';
          eyebrow.textContent='One leaf, many essentials';
          el.parentNode.insertBefore(eyebrow,el);
          el.innerHTML='What’s in it: one ingredient.<br>What’s not: everything else.';
          break;
        }
      }
    }catch(e){}
  }
  if(document.readyState!=='loading'){swap();}else{document.addEventListener('DOMContentLoaded',swap);}
  window.addEventListener('load',swap);
  setTimeout(swap,1200);setTimeout(swap,3000);
})();
/* === end AM_HOME_P24 === */

/* === AM_HOME_TABLE (2026-07-11, v3) — comparison-table de-densify + section footer polish.
   v3: the whole .am-badges emoji row is replaced with on-system ✓ chips (v2 only swapped the first badge,
   leaving two emoji boxes), and the .am-subline em dash is cleaned + the line gets on-system type via inline style. === */
(function(){
  if(window.location.pathname!=='/' && window.location.pathname!=='/index'){ return; }
  function upgrade(){
    try{
      var sec=document.getElementById('am-compare');
      if(!sec || sec.getAttribute('data-am-table')) return;
      var tbl=sec.querySelector('table');
      var scroll=sec.querySelector('.am-scroll');
      if(!tbl || !scroll) return;
      sec.setAttribute('data-am-table','1');
      var all=tbl.querySelectorAll('tr');
      var extras=[];
      for(var i=7;i<all.length;i++){ all[i].classList.add('am-extra'); extras.push(all[i]); }
      if(extras.length){
        var btn=document.createElement('button');
        btn.type='button';
        btn.className='am-cmp-toggle';
        btn.textContent='Show the full comparison ('+extras.length+' more rows)';
        btn.addEventListener('click',function(){
          var open=sec.classList.toggle('am-open');
          btn.textContent=open?'Show less':'Show the full comparison ('+extras.length+' more rows)';
        });
        scroll.parentNode.insertBefore(btn,scroll.nextSibling);
      }
      var hint=document.createElement('div');
      hint.className='am-cmp-swipe';
      hint.textContent='Swipe sideways to compare all four columns';
      scroll.parentNode.insertBefore(hint,scroll);
      var walk=document.createTreeWalker(sec,NodeFilter.SHOW_TEXT);var n;
      while((n=walk.nextNode())){
        if(n.textContent.indexOf('—naturally')!==-1){ n.textContent=n.textContent.replace(/—naturally/g,', naturally'); }
        if(n.textContent.indexOf(' — ')!==-1){ n.textContent=n.textContent.replace(/ — /g,', '); }
      }
      var foot=sec.querySelector('.am-footer');
      if(foot){
        var badges=foot.querySelector('.am-badges');
        if(badges && !badges.getAttribute('data-am-chips')){
          badges.setAttribute('data-am-chips','1');
          badges.innerHTML='<div class="am-chiprow" style="margin:26px auto 6px;"><span class="am-chip">✓ Whole-Food Nutrition</span><span class="am-chip">✓ No Synthetic Additives</span><span class="am-chip">✓ Family-Owned</span></div>';
        }
        var sl=foot.querySelector('.am-subline');
        if(sl){
          sl.style.fontFamily="'Inter','Helvetica Neue',Arial,sans-serif";
          sl.style.fontSize='.98rem';
          sl.style.color='#4A4838';
          sl.style.maxWidth='640px';
          sl.style.margin='20px auto 2px';
          sl.style.lineHeight='1.6';
        }
      }
    }catch(e){}
  }
  if(document.readyState!=='loading'){upgrade();}else{document.addEventListener('DOMContentLoaded',upgrade);}
  window.addEventListener('load',upgrade);
  setTimeout(upgrade,1200);setTimeout(upgrade,3000);
})();
/* === end AM_HOME_TABLE === */

/* === AM_SUBSCRIPTION_FREE_SHIP (2026-07-13) === Sitewide: shows "Free shipping on your first order" inside the Appstle
   Subscribe & Save option, on every product that carries a subscription plan (not just capsules -- no product/plan
   ID restriction here on purpose). Ties to the live Shopify automatic discount "Free Shipping First Month"
   (appliesOnSubscription only, recurringCycleLimit 1 = first billing cycle, US shipping, no minimum). Anchors on
   Appstle's own subscribe-option description slot so it works regardless of how many frequency choices a given
   product has. === */
(function () {
  if (window.location.pathname.indexOf('/products/') === -1) return;
  var busy = false;

  function styleOnce() {
    if (document.getElementById('am-sub-free-ship-style')) return;
    var css = '.am-sub-free-ship{display:flex;align-items:center;gap:6px;' +
      "font-family:'Inter','Helvetica Neue',Arial,sans-serif;font-size:0.82rem;" +
      'color:#4E5733;margin:6px 0 2px;line-height:1.3;}' +
      ".am-sub-free-ship:before{content:'✓';color:#C9A24B;font-weight:700;}";
    var s = document.createElement('style');
    s.id = 'am-sub-free-ship-style';
    s.textContent = css;
    document.head.appendChild(s);
  }

  function sweep() {
    if (busy) return;
    busy = true;
    try {
      styleOnce();
      document.querySelectorAll('.appstle_subscription_wrapper').forEach(function (w) {
        var anchor = w.querySelector('.appstle_subscription_description_text');
        if (!anchor) {
          var opts = w.querySelectorAll('.appstle_subscription_wrapper_option');
          var subOpt = opts[1] || null;
          anchor = subOpt ? subOpt.querySelector('.appstle_subscription_amount_wrapper') : null;
        }
        if (!anchor || !anchor.parentNode) return;
        if (anchor.parentNode.querySelector('.am-sub-free-ship')) return;
        var badge = document.createElement('div');
        badge.className = 'am-sub-free-ship';
        badge.textContent = 'Free shipping on your first order';
        anchor.insertAdjacentElement('afterend', badge);
      });
    } finally {
      busy = false;
    }
  }

  function start() {
    sweep();
    new MutationObserver(sweep).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
/* === end AM_SUBSCRIPTION_FREE_SHIP === */